import styled from '@emotion/styled'

import { palette } from 'main/ui'

export const height = 60
export const width = 60

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  background-color: ${palette.white};
  width: ${width}px;
  height: ${height}px;
  border-radius: 3px;
  padding-top: 2%;
`
